import {createMetaManager} from 'vue-meta';

export const metaManager = createMetaManager();
